import "./article.scss";
import { INewsArticleModel } from "../../core/models";
import Podcast from "../Podcast/Podcast";
import ActionFooter from "../ActionFooter/ActionFooter";
import ArticleInfo from "../ArticleInfo/ArticleInfo";

export interface IArticleSecondaryProps {
  content: INewsArticleModel;
}

const ArticleSecondary = ({ content }: IArticleSecondaryProps) => {
  const pushEventForShare = () => {
    if (window && (window as any)["ReactNativeWebView"]) {
      (window as any)["ReactNativeWebView"].postMessage(
        JSON.stringify({
          message: "eventLogForCountly",
          eventName: "Paylaş Butonu",
          eventSegment: { baslik: content?.news_title, tip: "Haber" },
          actionType: "event",
        })
      );
    }
  };

  if (window && (window as any)["ReactNativeWebView"]) {
    (window as any)["ReactNativeWebView"].postMessage(
      JSON.stringify({
        message: "eventLogForCountly",
        eventName: "Bülten Görütüleme",
        eventSegment: {
          baslik: content?.news_title,
          tarih: content?.news_date_f,
        },
        actionType: "event",
      })
    );
  }

  return (
    <>
      <article className="article-secondary">
        <div className="article-secondary__text">
          {content.news_title && (
            <h3 className="article-secondary__text-title">
              {content.news_title}
            </h3>
          )}

          <div className="article-secondary__head">
            <div className="article-secondary__head-bottom">
              <span>{content.news_date_f}</span>

              <span>{content.news_category_title}</span>
            </div>
          </div>

          {content.news_audiourl && (
            <Podcast
              content={{
                title: "",
                url: content.news_audiourl,
              }}
            ></Podcast>
          )}

          {content.news_summary && (
            <p
              className="article-secondary__text-description"
              dangerouslySetInnerHTML={{ __html: content.news_summary }}
            ></p>
          )}

          {content.news_imageurl && (
            <div className="article-secondary__image">
              <img
                src={content.news_imageurl}
                width={343}
                height={200}
                alt={content.news_title}
                style={{ height: "auto", width: "100%" }}
              />
            </div>
          )}

          {content.news_content && (
            <p
              className="article-secondary__text-description"
              dangerouslySetInnerHTML={{ __html: content.news_content }}
            ></p>
          )}
        </div>
      </article>

      <ArticleInfo></ArticleInfo>

      {content.page_shareurl && (
        <ActionFooter
          onHandleShare={pushEventForShare}
          content={{
            button_items: [
              {
                title: "Paylaş",
                url: content.page_shareurl,
              },
            ],
          }}
        />
      )}
    </>
  );
};

export default ArticleSecondary;
